import { WIDGET_INIT_LOADING, WIDGET_INIT_SUCCESS, WIDGET_INIT_FAIL, WIDGET_ADD, WIDGET_REMOVE, WIDGET_ADJUST } from '@/store/types'
import http, { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { widgets as widgetsParam } from '@/components/dashboard/widgets'

const state = {
  init: 0,
  menu: {},
  widgets: [],
  permitWidgets: []
}

const actions = {
  async initWidget({ commit, rootState }) {
    commit(WIDGET_INIT_LOADING)
    const apiUrl = rootState.app.menu.widgets
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        let dataResult = result.data
        // Format backend format to frontend format
        // front end format eg: { i: 'proposalData', x: 0, y: 0, w: 3, h: 1 }
        let formatWidgets = []
        if (dataResult.userWidgets && dataResult.userWidgets.length > 0) {
          dataResult.userWidgets.map(widget => {
            let formatWidget = {
              i: widget.id,
              x: widget.xAxis,
              y: widget.yAxis,
              w: widget.width,
              h: widget.height
            }
            formatWidgets.push(formatWidget)
          })
        }
        let formatPermitWidgets = {}
        if (dataResult.permitWidgets) {
          Object.keys(dataResult.permitWidgets).forEach(key => {
            Object.assign(formatPermitWidgets, {
              [key]: dataResult.permitWidgets[key]._links ? extractMenu(dataResult.permitWidgets[key]._links).init : ''
            })
          })
        }
        let commitResult = {
          menu: menu,
          widgets: formatWidgets,
          permitWidgets: formatPermitWidgets
        }
        commit(WIDGET_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(WIDGET_INIT_FAIL)
      }
    } else {
      commit(WIDGET_INIT_FAIL)
    }
  },
  async addWidget({ commit, state, getters }, data) {
    if (!state.widgets.find(x => x.i === data) && widgetsParam[data]) {
      const widgetParam = widgetsParam[data]
      const widget = {
        i: data,
        x: 0,
        y: getters.getWidgetNextYAxis,
        w: widgetParam.defW,
        h: widgetParam.defH
      }
      commit(WIDGET_ADD, widget)

      // We will commit widget before contacting server (for smooth experience)
      // Even if server contact fail, at most widget is not persisted (not too much dmg done)
      const apiUrl = state.menu.addWidget
      if (apiUrl) {
        try {
          const postData = {
            id: widget.i,
            xAxis: widget.x,
            yAxis: widget.y,
            width: widget.w,
            height: widget.h
          }
          await http.post(apiUrl, postData)
        } catch (error) { }
      }
    }
  },
  async removeWidget({ commit, state }, data) {
    if (state.widgets.find(x => x.i === data)) {
      commit(WIDGET_REMOVE, data)

      const apiUrl = state.menu.removeWidget
      if (apiUrl) {
        const expand = {
          id: String(data)
        }
        try {
          await http.delete(expandURI(apiUrl, expand))
        } catch (error) { }
      }
    }
  },
  async adjustWidget({ commit, state }, dataList) {
    let commitResult = []
    let postData = []
    dataList.map(widget => {
      const convert = {
        i: widget.i,
        x: widget.x,
        y: widget.y,
        w: widget.w,
        h: widget.h
      }
      commitResult.push(convert)

      const convertPost = {
        id: widget.i,
        xAxis: widget.x,
        yAxis: widget.y,
        width: widget.w,
        height: widget.h
      }
      postData.push(convertPost)
    })
    commit(WIDGET_ADJUST, commitResult)

    const apiUrl = state.menu.adjustWidgets
    if (apiUrl) {
      try {
        await http.post(apiUrl, postData)
      } catch (error) { console.log(error) }
    }
  }
}

const mutations = {
  [WIDGET_INIT_LOADING](state) {
    state.init = 0
  },
  [WIDGET_INIT_SUCCESS](state, data) {
    state.menu = data.menu
    state.widgets = data.widgets
    state.permitWidgets = data.permitWidgets
    state.init = 1
  },
  [WIDGET_INIT_FAIL](state) {
    state.init = 2
  },
  [WIDGET_ADD](state, data) {
    state.widgets.push(data)
  },
  [WIDGET_REMOVE](state, data) {
    try {
      state.widgets.splice(state.widgets.indexOf(state.widgets.find(x => x.i === data)), 1)
    } catch (err) { }
  },
  [WIDGET_ADJUST](state, data) {
    state.widgets = data
  }
}

const getters = {
  getWidgetNextYAxis: (state) => {
    // For new widget, we would like to add it to the next line
    if (state.widgets.length === 0) {
      return 0
    } else {
      const maxY = Math.max.apply(Math, state.widgets.map(function (o) { return o.y }))
      return maxY + 1
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
